module.exports = __webpack_public_path__ + "static/OpenDeFi-3fb47c317656ddea70d4382f4d4ab4b0.svg";